import { render } from "./Form.vue?vue&type=template&id=50d59881&scoped=true"
import script from "./Form.vue?vue&type=script&lang=ts"
export * from "./Form.vue?vue&type=script&lang=ts"

import "./Form.vue?vue&type=style&index=0&id=50d59881&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-50d59881"

export default script